import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { capitalize } from "lodash";
import { Image } from "../../../components";

export interface MovieCastCardProp {
  cast: string;
  poster?: string;
}

function MovieCastCard({ cast, poster }: MovieCastCardProp) {
  return (
    <Flex direction={"column"} width="fit-content" alignItems={"center"}>
      <Image
        sx={{
          borderRadius: "50%",
          overflow: "hidden",
        }}
        maxW={{
          base: "7rem",
        }}
        maxH={{
          base: "7rem",
          md: "10rem",
        }}
        border="2px solid white"
        h="full"
        itemProp="image"
        itemScope
        title={cast}
        objectFit="cover"
        src={
          poster ??
          `https://ui-avatars.com/api/?name=${cast}&size=512&rounded=true&bold=true`
        }
      />
      <Text
        my="0.5rem"
        width="fit-content"
        border="1px solid surface.10"
        p="0.2rem"
        maxW="15rem"
        borderRadius="0.5rem"
        backgroundColor={"surface.10"}
      >
        {capitalize(cast)}
      </Text>
    </Flex>
  );
}

export default MovieCastCard;
